import $ from "jquery";
window.addEventListener("px-ready", function () {
    var pagemode = localStorage.getItem('pagemode');
    if(pagemode === 'light'){
        $('.px-maincontent').addClass('is-reverse');
        $('body').addClass('is-reverse');
    }
    $('body').on('click','.js-switcher-dark',function(){
        $('.px-maincontent').removeClass('is-reverse');
        $('body').removeClass('is-reverse');
        localStorage.setItem('pagemode','dark')
        $('[name="theme-color"]').attr('content','#171616');
        return false;
    })
    $('body').on('click','.js-switcher-light',function(){
        $('.px-maincontent').addClass('is-reverse');
        $('body').addClass('is-reverse');
        localStorage.setItem('pagemode','light')
        $('[name="theme-color"]').attr('content','#fff');
        return false;
    })
})